import { Component, Input } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { LectureUserService } from '../shared/lecture-user.service';

@Component({
  selector: 'app-lecture-member-item',
  templateUrl: './lecture-member-item.component.html'
})
export class LectureMemberItemComponent {
  @Input() lecture: Lecture;
  @Input() user: any;

  constructor(private snackBar: MatSnackBar, private refService: LectureUserService) { }

  get state(): boolean {
    return this.user.state;
  }

  set state(value: boolean) {
    if (this.user.state !== value) {
      this.onSubmit(value);
    }
  }

  async onSubmit(value: boolean) {
    try {
      await this.refService.readRef(this.lecture.$key, this.user.$key).set({
        state: value
      });
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-member-item/lecture-member-item.component.ts